export default __webpack_public_path__ + "static/media/ne.7c9f18bf.svg";